angular.module('invoice')
    .component('ksefList', {
        bindings: {
            page: '<',
            filters: '<',
            statistics: '<'
        },
        templateUrl: 'app/invoice/ksef/list.html',
        controller: function ($scope, $state, $httpParamSerializer, $stateParams, Principal, User, Ksef, KsefService, Currency, KsefConst, InvoiceService, TableSelection) {
            this.reset = () => this.filters = {filter: this.filters.filter}

            this.$onInit = () => {
                this.selection = TableSelection.create(this.page.list, selected => this.totalAmount = this.sum(selected.length > 0 ? selected : this.page.list))
                this.subjectTypes = KsefService.subjectTypes()
                this.types = KsefService.types()
                this.currentTime = new Date()
                Currency.list().$promise.then(items => items.map(c => c.symbol)).then(items => this.currencies = items)
                this.totalAmount = this.sum(this.page.list)

                Principal.currentUser().then(user => {
                    this.isAdmin = Principal.hasAnyAuthority(['ROLE_ADMIN'])
                    this.canReadKSEF = Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_KSEF_REGISTRY', 'ROLE_INVOICE_DOCUMENTS_KSEF_SETTINGS'])
                })
            }

            this.deleteSelected = () => {
                if (!this.isAdmin || !this.selection.hasSelected()) {
                    return
                }
                return KsefService.removeMany(this.selection.selected)
            }
            this.sum = items => {
                let zeros = {netAmount: 0, vatAmount: 0, grossAmount: 0}
                return items.reduce((sum, it) => {
                    return {
                        netAmount: this.add(sum?.netAmount, it?.netAmount),
                        vatAmount: this.add(sum?.vatAmount, it?.vatAmount),
                        grossAmount: this.add(sum?.grossAmount, it?.grossAmount)
                    }
                }, zeros)
            }
            this.add = (value, add) => {
                return Math.round(value * 100 + add * 100) / 100
            }
            // this.passSelected = () => {
            //     return InvoiceService.passMany(this.selection.selected).then(() => $state.reload())
            // }

            $scope.$on(KsefConst.downloaded, () => $state.reload())
        }
    })
